module.exports = __webpack_public_path__ + "static/media/emergency-mapping.15421c71.jpg";